import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const Barcode = ({ value, height = 36, width = 1.2, className = '' }) => {
  const svgRef = useRef(null);
  const normalizedValue = String(value || '').trim();

  useEffect(() => {
    if (!svgRef.current || !normalizedValue) return;

    try {
      JsBarcode(svgRef.current, normalizedValue, {
        format: 'CODE128',
        displayValue: false,
        height,
        width,
        margin: 0,
      });
    } catch (error) {
      if (svgRef.current) {
        svgRef.current.innerHTML = '';
      }
    }
  }, [normalizedValue, height, width]);

  if (!normalizedValue) return null;

  return (
    <div className={`flex flex-col items-center ${className}`.trim()}>
      <svg ref={svgRef} className="w-full max-w-[200px]" />
      <span className="text-xs text-gray-600 mt-1">{normalizedValue}</span>
    </div>
  );
};

export default Barcode;
